import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Timeline.css";
import { EVENTS } from "./timelineConfig";
import TimelineItem from "./TimelineItem";
import RightArrowIcon from "../../components/RightArrowIcon";
import LeftArrowIcon from "../../components/LeftArrowIcon";
import { EVENT_GAP, EVENT_WIDTH } from "../../utils/consts";

export const Timeline: React.FC = () => {
  const topEvents = useMemo(() => {
    return EVENTS.filter((_, index) => index % 2 === 0);
  }, []);

  const bottomEvents = useMemo(() => {
    return EVENTS.filter((_, index) => index % 2 === 1);
  }, []);

  const [bottomVisibilities, setBottomVisibilities] = useState<boolean[]>(
    bottomEvents.map(() => false)
  );
  const [topVisibilities, setTopVisibilities] = useState<boolean[]>(
    topEvents.map(() => false)
  );

  const updateVisibility = (index: number, top: boolean) => {
    if (top)
      return (isVisible: boolean) => {
        setTopVisibilities((prev) => {
          const newVisibilities = [...prev];
          newVisibilities[index] = isVisible;
          return newVisibilities;
        });
      };
    else
      return (isVisible: boolean) => {
        setBottomVisibilities((prev) => {
          const newVisibilities = [...prev];
          newVisibilities[index] = isVisible;
          return newVisibilities;
        });
      };
  };

  const canNavLeft = useMemo(() => {
    return topVisibilities && !topVisibilities[0];
  }, [topVisibilities]);

  const canNavRight = useMemo(() => {
    if (bottomEvents.length < topEvents.length) {
      return topVisibilities && !topVisibilities[topVisibilities.length - 1];
    }
    return (
      bottomVisibilities && !bottomVisibilities[bottomVisibilities.length - 1]
    );
  }, [topVisibilities, bottomVisibilities, bottomEvents, topEvents]);

  const topEventsElement = useRef<HTMLDivElement>(null);
  const scrollElement = useRef<HTMLDivElement>(null);
  const [barwidth, setBarwidth] = useState(0);

  const navRight = () => {
    const allVisible: boolean[] = [];
    bottomVisibilities.forEach((_, i) => {
      allVisible[2 * i + 1] = bottomVisibilities[i];
      console.log(i, 2 * i + 1);
    });
    topVisibilities.forEach((_, i) => {
      allVisible[2 * i] = topVisibilities[i];
      console.log(i, 2 * i);
    });
    console.log(allVisible);
    const firstVisible = allVisible.findIndex((val) => val);
    const firstInvisible = allVisible.findIndex(
      (val, i) => !val && i > firstVisible
    );
    let leftScroll;
    const ind = Math.floor(firstInvisible / 2);
    if (firstInvisible % 2 === 0) {
      leftScroll = (EVENT_WIDTH + EVENT_GAP) * ind;
    } else {
      console.log(`ind: ${ind}`);
      leftScroll =
        (EVENT_WIDTH + EVENT_GAP) * ind + (EVENT_WIDTH + EVENT_GAP) / 2;
    }
    scrollElement.current?.scrollTo({
      left: leftScroll,
      behavior: "smooth",
    });
    console.log(`scrolling to ${leftScroll}`);
  };

  const navLeft = () => {
    const allVisible: boolean[] = [];
    bottomVisibilities.forEach((_, i) => {
      allVisible[2 * i + 1] = bottomVisibilities[i];
      console.log(i, 2 * i + 1);
    });
    topVisibilities.forEach((_, i) => {
      allVisible[2 * i] = topVisibilities[i];
      console.log(i, 2 * i);
    });
    console.log(allVisible);
    const firstVisible = allVisible.findIndex((val) => val);
    const firstInvisible = firstVisible - 1;
    let leftScroll;
    const ind = Math.floor(firstInvisible / 2);
    if (firstInvisible % 2 === 0) {
      leftScroll = (EVENT_WIDTH + EVENT_GAP) * ind;
    } else {
      leftScroll =
        (EVENT_WIDTH + EVENT_GAP) * ind + (EVENT_WIDTH + EVENT_GAP) / 2;
    }
    leftScroll += EVENT_WIDTH + EVENT_GAP / 2;
    leftScroll -= scrollElement.current?.offsetWidth || 0;

    scrollElement.current?.scrollTo({
      left: leftScroll,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setBarwidth(topEventsElement.current?.offsetWidth || 0);
  }, []);

  return (
    <div className="expand flex relative flexdir-col">
      <div className="title-abs-container">
        <div className="title timeline">Dartmouth Energy Timeline</div>
      </div>
      <div ref={scrollElement} className="no-scrollbar timelinecontainer flex">
        {/* top timeline events */}
        <div
          className="flex items-end timelinerow"
          style={{ gap: EVENT_GAP }}
          ref={topEventsElement}
        >
          {topEvents.map((event, index) => (
            <TimelineItem
              event={event}
              top={true}
              key={event.name}
              updateVisibility={updateVisibility(index, true)}
            />
          ))}
        </div>
        <div className="middlebar" style={{ width: barwidth }}></div>
        <div style={{ marginBottom: -182, marginLeft: 70 }}>
          <div className="clickMeBox">
            <img className="clickMeIcon" src="/lightbulbs/lit.svg" alt="" />
            <p className="clickMeText">Tap each picture to learn more!</p>
          </div>
        </div>
        {/* bottom timeline events */}
        <div
          className="flex items-start timelinerow"
          style={{ gap: EVENT_GAP, paddingLeft: (EVENT_WIDTH + EVENT_GAP) / 2 }}
        >
          {bottomEvents.map((event, index) => (
            <TimelineItem
              event={event}
              top={false}
              key={event.name}
              updateVisibility={updateVisibility(index, false)}
            />
          ))}
        </div>
      </div>
      <div className="navbuttonscontainer">
        <button
          type="button"
          className="navbutton transition"
          disabled={!canNavLeft}
          style={{ opacity: canNavLeft ? 1 : 0.6 }}
          onClick={navLeft}
        >
          <LeftArrowIcon style={{ width: 20, paddingRight: 7 }} />
        </button>
        <button
          type="button"
          className="navbutton transition"
          disabled={!canNavRight}
          style={{ opacity: canNavRight ? 1 : 0.6 }}
          onClick={navRight}
        >
          <RightArrowIcon style={{ width: 20, paddingLeft: 7 }} />
        </button>
      </div>
    </div>
  );
};
